import styled from 'styled-components';
import { Wrapper } from './TagChips.styles';

export { Chip } from './TagChips.styles';

/* Same chip row as the galleries, sitting just under the file preview. */
export const TagRow = styled(Wrapper)`
  margin-top: 6px;
`;
